import { MAT_COLOR_FORMATS, NGX_MAT_COLOR_FORMATS } from '@angular-material-components/color-picker';
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Inject,
    Input,
    OnChanges, OnDestroy,
    Output,
    SimpleChanges,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { FormControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatCalendarCellCssClasses } from '@angular/material/datepicker';
import { MatLegacyDialog as MatDialog, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import moment from 'moment';
import { Moment } from 'moment';
import { firstValueFrom, Observable, ReplaySubject, Subscription } from 'rxjs';
import { Address, getAddressString, isNotNullOrUndefined } from '../../../../../helper/helper';
import { getErrorMessage, hasRequiredValidator } from "../../../../../helper/validation.helper";
import {
    SelectSearchData,
    SelectSearchLegacyComponent,
} from '../../../../select-search/components/select-search-legacy/select-search-legacy.component';
import { SelectSearchOption } from '../../../../select-search/components/select-search/select-search.component';
import { AbstractControlTyped, FormGroupTyped } from '../../../../typings';
import { BreakpointObserverService } from '../../../services/breakpoint-observer.service';
import { MapDialogComponent } from '../../dialogs/map-dialog/map-dialog.component';
import { CustomPropertyType, IProfileTemplateData } from '../profile-template/profile-template.component';
import { QueryParamsHandling } from '@angular/router';
import {
    EmailEditorComponent, EmailEditorComponentDialogConfig,
    EmailEditorComponentDialogData,
} from '../../../../../dave-email-module/components/email-editor/email-editor.component';
import { AccountTypeEnum } from '../../../../../dave-data-module/entities/chart-of-Account.entity';
import { CustomLabelService } from '../../../../../services/custom-label/custom-label.service';
import { Person2EntityActionTypes } from '../../../../../dave-data-module/State/actions/person2entity.action';
import { Person2EntityEntityTypeEnum } from '../../../../../dave-data-module/entities/person2entity.entity';
import { getCustomerById } from '../../../../../dave-data-module/State/selectors/customers.selectors';
import { Store } from '@ngrx/store';
import { State } from '../../../../../dave-data-module/State';
import {
    NewCustomerDialogComponent,
    NewCustomerDialogComponentDialogData, NewCustomerDialogComponentDialogReturnData,
} from '../../../../../components/new-view/new-customer/new-customer-dialog/new-customer-dialog.component';
import {
    PersonModalComponent,
    PersonModalComponentDialogData,
} from '../../../../../dave-person-module/components/person-modal/person-modal';
import { getPersonById } from '../../../../../dave-data-module/State/selectors/person.selectors';
import { GermanPaginatorIntl } from '../../../../../services/german-paginator-intl.service';
import { LegacyPageEvent as PageEvent, MatLegacyPaginator as MatPaginator, MatLegacyPaginatorIntl as MatPaginatorIntl, MatLegacyPaginatorModule } from '@angular/material/legacy-paginator';
import { CustomerDataService } from '../../../../../dave-data-module/services/customer-data.service';

export interface DetailListTemplatePropertySpecialInputType<T = any> {
    select?: { optionValue: any; optionLabel: string; optionIcon?: { iconProp: IconProp; color?: string } }[];
    /**
     * @deprecated use {@link singleSelectSearch} instead
     */
    selectSearch?: { optionValue: number; optionLabel: string; optionSearch?: string }[];
    singleSelectSearch?: {
        optionTemplate?: TemplateRef<any>;
        options?: SelectSearchOption<T>[];
        options$?: Observable<SelectSearchOption<T>[]>;
        compareOptions?: (a: SelectSearchOption<T>, b: SelectSearchOption<T>) => boolean;
        searchFunction?: (search: string, option: SelectSearchOption<T>) => boolean;

        serverSearch?: (search: string) => void;
        pageChange?: (event: PageEvent) => void;
        pageIndex$?: Observable<number>;
        pageCount$?: Observable<number>;
        loading$?: Observable<boolean>;
    };

    location?: {
        value: Partial<Address>;
        formGroup?: FormGroupTyped<Address> | AbstractControlTyped<Address> | FormGroup | FormControl<Address> ;
        options?: SelectSearchOption<{ searchValues?: string[]; value: Address }>[]
    };
    radioGroup?: {
        options: { label: string; value: any }[];
    };
    chipAutocomplete?: {
        MapFn: (option: T) => string;
        CompareFn?: (a: T, b: T) => boolean;
        Options?: ReadonlyArray<any>;
        Options$?: Observable<ReadonlyArray<any>>;
        onClick?: (option) => void;
        onUnknownOptionSubmitted?: (string: string) => void;
        OptionTemplate?: TemplateRef<any>;
        initialPatchDefaultValue?: boolean;
        removeAllButton?: boolean;
        removeAllButtonText?: string;
    };
    autocomplete?: {
        MapFn: (option) => string;
        FilterFn: (option, searchString: string) => boolean;
        DeleteFn?: (option) => void;
        Options: ReadonlyArray<any>;
    };
    customTemplate?: TemplateRef<any>;
    date?:  boolean  | { matDatepickerFilter?: (date) => boolean; dateClass?: (date: moment.Moment) => MatCalendarCellCssClasses; withTime?: boolean; timeFormControl?: FormControl<string | null> };
    boolean?: boolean;
    number?: boolean;
    weekDaySelector?: 'checkbox' | 'number';
    textArea?: { Fill: boolean, MinRows?: number };
    timeSpan?: { formControlFrom: FormControl<Moment>; formControlTo: FormControl<Moment> };
    colorPicker?: boolean;
    fileName?: boolean;
    travelZoneId?: {requiredId?: number};
    password? : boolean;
}
export interface IDetailListTemplateDataProperty<T = any> {
    onlyIcon?: IconProp;
    key: string;
    value?: string | Date | boolean | number;
    formControl?: FormControl<T> | UntypedFormControl | AbstractControlTyped<T>;
    hideFormControl?: boolean;
    options?: {
        type?: CustomPropertyType;
        specialInput?: DetailListTemplatePropertySpecialInputType<T>;
        showHint?: string;
        detailDialogData?: DetailDialogData;
        suffix?: string;
        wordBreak?: boolean;
        routerLinkPayload?: {
            routerLink?: string | any[];
            queryParams?: {[key: string]: any};
            queryParamsHandling?: QueryParamsHandling | null;
        }
        showAddCustomerButton?: NewCustomerDialogComponentDialogData;
        showAddPersonButton?: PersonModalComponentDialogData;
        linkPayload?: {
            href?: string;
        }
    };
}
export interface IDetailListTemplateData {
    HeaderIcon?: IconProp;
    ObjectData?: any;
    Headline?: string;
    Subline?: string;
    Properties?: IDetailListTemplateDataProperty[];
    CornerColor?: string;
}
export const hasRequiredField = hasRequiredValidator;
@Component({
    selector: 'app-detail-list-template',
    templateUrl: './detail-list-template.component.html',
    styleUrls: ['./detail-list-template.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ provide: MAT_COLOR_FORMATS, useValue: NGX_MAT_COLOR_FORMATS},{ provide: MatPaginatorIntl, useClass: GermanPaginatorIntl }],
})
export class DetailListTemplateComponent implements OnChanges, AfterViewInit, OnDestroy {

    protected data: IDetailListTemplateData;
    protected onlyIcons: boolean;
    @Input() set Data(value: IDetailListTemplateData) {
        this.data = value;
        this.onlyIcons = value?.Properties?.every((p) => p?.onlyIcon);
    }
    @ViewChild('selectSearchLegacy') selectSearchLegacy!: SelectSearchLegacyComponent;
    @Input() Editing = false;
    @Input() Wrapped = true;
    @Input() Inline = false;
    @Input() RequiredAdress = false;
    @Input() AutofocusIndex = 0;
    @Output() Submit = new EventEmitter<void>();
    // nur für das html form
    public FormGroup = new UntypedFormGroup({});
    public PropertyType = CustomPropertyType;
    public EditableProperties$ = new ReplaySubject<IDetailListTemplateDataProperty[]>(1);
    public CustomPropertyType = CustomPropertyType;
    public GetErrorMessage = getErrorMessage;
    public HasRequiredField = hasRequiredField;
    public WeekDayNames = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
    private valueChangeSubscriptions: Subscription[] = [];
    constructor(private store: Store<State>,public Dialog: MatDialog, private rootElement: ElementRef, public BS: BreakpointObserverService, protected cls: CustomLabelService, private customerDataService: CustomerDataService, private cdr: ChangeDetectorRef) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.Data?.currentValue?.Properties) {
            this.EditableProperties$.next(
                (changes.Data.currentValue as DetailListTemplateComponent['Data']).Properties?.filter((property) => (property.formControl || property.options?.specialInput?.location?.formGroup) && property.key).map((v) => {
                    return {
                        ...v,
                        searchSelect: v.options?.specialInput?.selectSearch ? this.MapSelectInputToSelectSearchInput(v.options?.specialInput?.selectSearch) : null,
                    };
                }),
            );
            this.subscribeToValueChanges((changes.Data.currentValue as DetailListTemplateComponent['Data']).Properties);
        }
    }

    /**
     * Diese Component ist OnPush. Werden die Formulare von außen (programmatisch) gesetzt, würde die View sonst
     * nicht neu geprüft werden, z.B. bleibt dann das Label / der Placeholder über dem neuen Wert stehen.
     */
    private subscribeToValueChanges(properties: IDetailListTemplateDataProperty[]) {
        this.valueChangeSubscriptions.forEach((s) => s.unsubscribe());
        this.valueChangeSubscriptions = [];
        properties?.forEach((property) => {
            const date = property?.options?.specialInput?.date;
            const timeSpan = property?.options?.specialInput?.timeSpan;
            [
                property?.formControl,
                property?.options?.specialInput?.location?.formGroup,
                typeof date === 'object' ? date.timeFormControl : null,
                timeSpan?.formControlFrom,
                timeSpan?.formControlTo,
            ]
                .filter(isNotNullOrUndefined)
                .forEach((control) => this.valueChangeSubscriptions.push(control.valueChanges.subscribe(() => this.cdr.markForCheck())));
        });
    }

    public OpenMapDialog(location: Partial<Address>) {
        this.Dialog.open(MapDialogComponent, {
            ...MapDialogComponent.DefaultConfig,
            data: location,
        });
    }
    public OpenMailDialog(targets: string[]) {
        this.Dialog.open<EmailEditorComponent, EmailEditorComponentDialogData>(EmailEditorComponent, {
            ...EmailEditorComponentDialogConfig,
            data: {
                TargetEmails:targets.filter(v => !!v),
            },
        });
    }

    public autoCompleteValues(property: IDetailListTemplateDataProperty, searchString: string) {
        // searchString kann durch einen unbekannten Bug auch truthy aber kein string sein D277-2006 https://glitchtip.dave-cc.com/dave/issues/41169?project=5
        return typeof searchString === 'string'
            ? property.options?.specialInput.autocomplete.Options.filter((o) => property.options?.specialInput.autocomplete.FilterFn(o, searchString))
            : property.options?.specialInput.autocomplete.Options;
    }

    public OpenDetailDialog(property: IDetailListTemplateDataProperty) {
        this.Dialog.open(ProfileTemplateDetailDialogComponent, {
            data: property.options?.detailDialogData,
            // panelClass: 'popup-dialog',
            autoFocus: false,
            panelClass: 'custom-dialog-class-without-padding',
            minWidth: '20rem',
        });
    }

    public MapSelectInputToSelectSearchInput(values: { optionValue: any; optionLabel: string; optionSearch?: string }[]) {
        return values.map((v) => {
            return {
                Name: v.optionLabel,
                SearchContent: v?.optionSearch,
                Id: typeof v.optionValue === 'number' ? v.optionValue : -1,
            } as SelectSearchData;
        });
    }
    public SelectOptionIcon = (p: IDetailListTemplateDataProperty) => p.options.specialInput.select.find((s) => s.optionValue === p.formControl.value)?.optionIcon;
    public UpdateArrayValue(formControl: UntypedFormControl, index: number, value: any) {
        const arr: any[] = formControl.value.slice();
        arr[index] = value;
        formControl.setValue(arr);
    }

    ngAfterViewInit(): void {
        const autofocusElements = this.rootElement.nativeElement.getElementsByClassName('autofocus');
        const autoFocusInputs = autofocusElements?.length ? autofocusElements[0].getElementsByTagName('input') : null;
        if (autoFocusInputs?.length) {
            autoFocusInputs[0].focus();
        }
    }

    ngOnDestroy(): void {
        this.EditableProperties$.complete();
        this.valueChangeSubscriptions.forEach((s) => s.unsubscribe());
    }

    protected readonly hasRequiredField = hasRequiredField;


    protected readonly AccountTypeEnum = AccountTypeEnum;

    //todo openedFromPagedSelectSearch can be removed if customers select arnt uesed anymore
    onAddCustomerButtonClick(formControl: FormControl<SelectSearchData>, data: NewCustomerDialogComponentDialogData, openedFromPagedSelectSearch: boolean) {
        import('../../../../../components/new-view/new-customer/new-customer-dialog/new-customer-dialog.component').then((m) => {
            const dialogRef = this.Dialog.open<NewCustomerDialogComponent, NewCustomerDialogComponentDialogData, NewCustomerDialogComponentDialogReturnData>(m.NewCustomerDialogComponent, {
                ...m.NewCustomerDialogComponent.DefaultConfig,
                data
            });

            dialogRef.afterClosed().subscribe(async (customerId) => {
                if (customerId) {
                    if (openedFromPagedSelectSearch) {
                        const customerData = await firstValueFrom(this.customerDataService.GetSingleCustomer$(customerId));
                        // markAsDirty vor setValue, damit Konsumenten die Auswahl in valueChanges als Nutzeraktion erkennen können
                        formControl.markAsDirty();
                        formControl.setValue(customerData);
                    } else {
                        const customerData = await firstValueFrom(this.store.select(getCustomerById({ id: customerId })));

                        // markAsDirty vor setValue, damit Konsumenten die Auswahl in valueChanges als Nutzeraktion erkennen können
                        formControl.markAsDirty();
                        formControl.setValue({
                            Name: isNotNullOrUndefined(customerData.CustomerNo)
                                ? customerData.CustomerNo +
                                (+' ' + customerData.DisplayName)
                                : customerData.DisplayName,
                            Id: customerId
                        });
                    }
                }
            });

        });
    }
    private newPersonDefaultValues: PersonModalComponentDialogData['newPersonDefaultValues'];
    onAddPersonButtonClick(formControl: FormControl<SelectSearchData>, data: NewCustomerDialogComponentDialogData) {

            this.Dialog
                .open<PersonModalComponent, PersonModalComponentDialogData>(PersonModalComponent, {
                    ...PersonModalComponent.DefaultConfig,
                    data: {
                        newPersonDefaultValues: this.newPersonDefaultValues,

                    },
                    // panelClass: 'custom-dialog-class-without-padding-margin-top-1-75',
                })
                .afterClosed()
                .subscribe(async newPerson => {
                    if (newPerson) {
                        formControl.setValue({
                            Name: newPerson.Person.DisplayName,
                            Id: newPerson.Person.Id
                        });
                    }
                });

    }


    protected onRadioClick($event: MouseEvent, formControl: FormControl<any> | AbstractControlTyped<any>, value: any) {
        if (formControl.value === value && !hasRequiredValidator(formControl)) {
            $event.stopPropagation();
            $event.preventDefault();
            formControl.setValue(null);
        }
    }

    protected getLink(url: string) {
        return url?.includes('//') ? url : '//' + url
    }
    trackByPropertyKey(index: number, property: IDetailListTemplateDataProperty) {
        return property.key;
    }
}
interface DetailDialogData {
    content?: IProfileTemplateData;
    routingButtonRoute?: any[] | string | null | undefined;
}

@Component({
    selector: 'app-profile-template-detail-dialog',
    template: `
        <app-profile-template [Editing]="false" [Data]="Data.content"></app-profile-template>
        <a *ngIf="Data?.routingButtonRoute" app-round-button mat-dialog-close [routerLink]="Data.routingButtonRoute">
            <fa-icon icon="share"></fa-icon>
        </a>
    `,
    styles: [
        `
                    :host {
                        display: block;
                        position: relative;
                    }
                    a {
                        position: absolute;
                        right: 1rem;
                        bottom: 1rem;
                    }
                `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileTemplateDetailDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public Data: DetailDialogData) {}
}
